import React from 'react'
import { logo } from "../../assets/index";

const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-center relative aspect-square max-w-[500px] mx-auto">
      {/* <img
        className="w-full h-full object-cover rounded z-10"
        src={bannerImg}
        alt="bannerImg"
      /> */}
      <video
        className="h-full w-full object-cover rounded-full rounded z-10"
        src={logo}
        alt="logo"
        autoPlay
        loop
        muted
        playsInline
      />
      {/* <div className="absolute bottom-0 w-[350px] h-[300px] lgl:w-[500px] lgl:h-[500px] bg-gradient-to-r from-[#1e2024] to-[#202327] shadow-shadowOne flex justify-center items-center"></div> */}
    </div>
  );
}

export default RightBanner